import {ClassComponent, Vnode, VnodeDOM} from 'mithril';

interface ProgressBarAttrs {
    progress: number | (() => number)
    label?: (percent: Vnode) => Vnode
}

export default class ProgressBar implements ClassComponent<ProgressBarAttrs> {
    refreshTimeout!: number

    oncreate(vnode: VnodeDOM<ProgressBarAttrs>) {
        const {progress} = vnode.attrs;

        // We allow the use of a refresh because redrawing the whole app just for the progress bar doesn't make sense
        if (typeof progress === 'function') {
            const refresh = () => {
                this.refreshTimeout = setTimeout(() => {
                    window.requestAnimationFrame(() => {
                        const value = Math.round(progress());

                        (vnode.dom.querySelector('.CimaiseProgressBar') as HTMLElement).style.width = value + '%';

                        const percent = vnode.dom.querySelector('.CimaiseProgressPercent');

                        // The percent might not be visible if the custom label template does not include it
                        if (percent) {
                            percent.textContent = value + '%';
                        }

                        refresh();
                    });
                }, 100) as any;
            };

            refresh();
        }
    }

    onremove() {
        clearTimeout(this.refreshTimeout);
    }

    view(vnode: Vnode<ProgressBarAttrs>) {
        const {progress, label} = vnode.attrs;

        const progressIsFunction = typeof progress === 'function';

        return m('.CimaiseProgress', [
            m('.CimaiseProgressBar', {
                style: {
                    width: progressIsFunction ? '0' : progress + '%',
                },
            }),
            m('.CimaiseProgressLabel', this.label(progressIsFunction ? 0 : <number>progress, label)),
        ]);
    }

    label(progressValue: number, labelDefinition?: (percent: Vnode) => Vnode) {
        const progressPercent = m('span.CimaiseProgressPercent', progressValue + '%');

        if (labelDefinition) {
            return labelDefinition(progressPercent);
        }

        return progressPercent;
    }
}
